// Clay / Handmade category step images

import clayCatchAllTrayCh2S2 from '@/assets/step-images/clay-catch-all-tray-ch2-s2.jpg';
import clayCatchAllTrayCh2S5 from '@/assets/step-images/clay-catch-all-tray-ch2-s5.jpg';
import clayCatchAllTrayCh3S2 from '@/assets/step-images/clay-catch-all-tray-ch3-s2.jpg';
import clayCatchAllTrayCh3S5 from '@/assets/step-images/clay-catch-all-tray-ch3-s5.jpg';
import clayCoastersCh3S2 from '@/assets/step-images/clay-coasters-ch3-s2.jpg';
import cyanotypePrintCh2S5 from '@/assets/step-images/cyanotype-print-ch2-s5.jpg';
import cyanotypePrintCh3S1 from '@/assets/step-images/cyanotype-print-ch3-s1.jpg';
import cyanotypePrintCh3S5 from '@/assets/step-images/cyanotype-print-ch3-s5.jpg';
import discoBallPlanterCh3S2 from '@/assets/step-images/disco-ball-planter-ch3-s2.jpg';
import discoBallPlanterCh3S5 from '@/assets/step-images/disco-ball-planter-ch3-s5.jpg';
import handmadeCandleCh1S4 from '@/assets/step-images/handmade-candle-ch1-s4.jpg';
import handmadeCandleCh2S5 from '@/assets/step-images/handmade-candle-ch2-s5.jpg';
import handmadeCandleCh3S5 from '@/assets/step-images/handmade-candle-ch3-s5.jpg';
import kintsugiPlateCh1S1 from '@/assets/step-images/kintsugi-plate-ch1-s1.jpg';
import kintsugiPlateCh3S5 from '@/assets/step-images/kintsugi-plate-ch3-s5.jpg';
import matchingJewelrySetCh1S4 from '@/assets/step-images/matching-jewelry-set-ch1-s4.jpg';
import matchingJewelrySetCh3S3 from '@/assets/step-images/matching-jewelry-set-ch3-s3.jpg';
import pinchBowlCh2S5 from '@/assets/step-images/pinch-bowl-ch2-s5.jpg';
import repairedCeramicTrayCh1S1 from '@/assets/step-images/repaired-ceramic-tray-ch1-s1.jpg';
import repairedCeramicTrayCh1S4 from '@/assets/step-images/repaired-ceramic-tray-ch1-s4.jpg';
import repairedCeramicTrayCh3S4 from '@/assets/step-images/repaired-ceramic-tray-ch3-s4.jpg';
import stampedIncenseHolderCh2S1 from '@/assets/step-images/stamped-incense-holder-ch2-s1.jpg';
import stampedIncenseHolderCh2S5 from '@/assets/step-images/stamped-incense-holder-ch2-s5.jpg';
import stampedIncenseHolderCh3S2 from '@/assets/step-images/stamped-incense-holder-ch3-s2.jpg';
import stampedIncenseHolderCh3S4 from '@/assets/step-images/stamped-incense-holder-ch3-s4.jpg';
import stampedIncenseHolderCh3S5 from '@/assets/step-images/stamped-incense-holder-ch3-s5.jpg';

import sculpturalTrinketDishCh1S1 from '@/assets/step-images/sculptural-trinket-dish-ch1-s1.jpg';
import sculpturalTrinketDishCh1S2 from '@/assets/step-images/sculptural-trinket-dish-ch1-s2.jpg';
import sculpturalTrinketDishCh1S3 from '@/assets/step-images/sculptural-trinket-dish-ch1-s3.jpg';
import sculpturalTrinketDishCh1S4 from '@/assets/step-images/sculptural-trinket-dish-ch1-s4.jpg';
import sculpturalTrinketDishCh1S5 from '@/assets/step-images/sculptural-trinket-dish-ch1-s5.jpg';
import sculpturalTrinketDishCh2S1 from '@/assets/step-images/sculptural-trinket-dish-ch2-s1.jpg';
import sculpturalTrinketDishCh2S2 from '@/assets/step-images/sculptural-trinket-dish-ch2-s2.jpg';
import sculpturalTrinketDishCh2S3 from '@/assets/step-images/sculptural-trinket-dish-ch2-s3.jpg';
import sculpturalTrinketDishCh2S4 from '@/assets/step-images/sculptural-trinket-dish-ch2-s4.jpg';
import sculpturalTrinketDishCh2S5 from '@/assets/step-images/sculptural-trinket-dish-ch2-s5.jpg';
import sculpturalTrinketDishCh3S1 from '@/assets/step-images/sculptural-trinket-dish-ch3-s1.jpg';
import sculpturalTrinketDishCh3S2 from '@/assets/step-images/sculptural-trinket-dish-ch3-s2.jpg';
import sculpturalTrinketDishCh3S3 from '@/assets/step-images/sculptural-trinket-dish-ch3-s3.jpg';
import sculpturalTrinketDishCh3S4 from '@/assets/step-images/sculptural-trinket-dish-ch3-s4.jpg';
import sculpturalTrinketDishCh3S5 from '@/assets/step-images/sculptural-trinket-dish-ch3-s5.jpg';

export const CLAY_HANDMADE_IMAGES: Record<string, string> = {
  'clay-catch-all-tray-ch2-s2': clayCatchAllTrayCh2S2,
  'clay-catch-all-tray-ch2-s5': clayCatchAllTrayCh2S5,
  'clay-catch-all-tray-ch3-s2': clayCatchAllTrayCh3S2,
  'clay-catch-all-tray-ch3-s5': clayCatchAllTrayCh3S5,
  'clay-coasters-ch3-s2': clayCoastersCh3S2,
  'cyanotype-print-ch2-s5': cyanotypePrintCh2S5,
  'cyanotype-print-ch3-s1': cyanotypePrintCh3S1,
  'cyanotype-print-ch3-s5': cyanotypePrintCh3S5,
  'disco-ball-planter-ch3-s2': discoBallPlanterCh3S2,
  'disco-ball-planter-ch3-s5': discoBallPlanterCh3S5,
  'handmade-candle-ch1-s4': handmadeCandleCh1S4,
  'handmade-candle-ch2-s5': handmadeCandleCh2S5,
  'handmade-candle-ch3-s5': handmadeCandleCh3S5,
  'kintsugi-plate-ch1-s1': kintsugiPlateCh1S1,
  'kintsugi-plate-ch3-s5': kintsugiPlateCh3S5,
  'matching-jewelry-set-ch1-s4': matchingJewelrySetCh1S4,
  'matching-jewelry-set-ch3-s3': matchingJewelrySetCh3S3,
  'pinch-bowl-ch2-s5': pinchBowlCh2S5,
  'repaired-ceramic-tray-ch1-s1': repairedCeramicTrayCh1S1,
  'repaired-ceramic-tray-ch1-s4': repairedCeramicTrayCh1S4,
  'repaired-ceramic-tray-ch3-s4': repairedCeramicTrayCh3S4,
  'sculptural-trinket-dish-ch1-s1': sculpturalTrinketDishCh1S1,
  'sculptural-trinket-dish-ch1-s2': sculpturalTrinketDishCh1S2,
  'sculptural-trinket-dish-ch1-s3': sculpturalTrinketDishCh1S3,
  'sculptural-trinket-dish-ch1-s4': sculpturalTrinketDishCh1S4,
  'sculptural-trinket-dish-ch1-s5': sculpturalTrinketDishCh1S5,
  'sculptural-trinket-dish-ch2-s1': sculpturalTrinketDishCh2S1,
  'sculptural-trinket-dish-ch2-s2': sculpturalTrinketDishCh2S2,
  'sculptural-trinket-dish-ch2-s3': sculpturalTrinketDishCh2S3,
  'sculptural-trinket-dish-ch2-s4': sculpturalTrinketDishCh2S4,
  'sculptural-trinket-dish-ch2-s5': sculpturalTrinketDishCh2S5,
  'sculptural-trinket-dish-ch3-s1': sculpturalTrinketDishCh3S1,
  'sculptural-trinket-dish-ch3-s2': sculpturalTrinketDishCh3S2,
  'sculptural-trinket-dish-ch3-s3': sculpturalTrinketDishCh3S3,
  'sculptural-trinket-dish-ch3-s4': sculpturalTrinketDishCh3S4,
  'sculptural-trinket-dish-ch3-s5': sculpturalTrinketDishCh3S5,
  'stamped-incense-holder-ch2-s1': stampedIncenseHolderCh2S1,
  'stamped-incense-holder-ch2-s5': stampedIncenseHolderCh2S5,
  'stamped-incense-holder-ch3-s2': stampedIncenseHolderCh3S2,
  'stamped-incense-holder-ch3-s4': stampedIncenseHolderCh3S4,
  'stamped-incense-holder-ch3-s5': stampedIncenseHolderCh3S5,
};
